import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="app--user-participant-form"
export default class extends Controller {
	static targets = [
		'newParticipantSection',
		'formSection',
		'createParticipantInput'
	]

	static values = {
		participantExists: Boolean,
	}

	connect() {
		this.updateNewParticipantSection()
		this.updateFormSection()
	}

	updateNewParticipantSection() {
		if (this.participantExistsValue) {
			this.newParticipantSectionTarget.classList.add('d-none')
		} else {
			this.newParticipantSectionTarget.classList.remove('d-none')
		}
	}

	updateFormSection(_event) {
		if (this.participantExistsValue || this.createParticipantInputTarget.checked) { 
			this.formSectionTarget.classList.remove('d-none')

			this.formSectionTarget
				.querySelectorAll('input, select')
				.forEach( (element) => element.disabled = false )
		} else {
			this.formSectionTarget.classList.add('d-none')

			this.formSectionTarget
				.querySelectorAll('input, select')
				.forEach( (element) => element.disabled = true )
		}
	}
}
